<div class="m-multi-row w-100" [formGroup]="liability">
		<div class="form-row row">
		<button type="button" *ngIf="displayX" class="close" aria-label="Close" (click)="removed.emit(index)">
				<span aria-hidden="true">&times;</span>
		</button>
			<div class="col-sm-12 col-md-12 col-lg-3  input-wrapper pr-0 w-100 mt-3">
				<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{"LIABILITIES.QUESTION5.LIABILITY_TYPE"|translate}}</label>

					<app-dplist-new [valueArr]='types' formControlName="liabilityType"></app-dplist-new>
					<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="liability.get('liabilityType').hasError('required') && displayErrors">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
			</div>
			<div class="form-group col-12 col-lg-3 input-wrapper mt-3">
				<app-animated-input formControlName="liabilityBalance" [type]="'text'" [attrId]="'liabilityBalance'+index" placeholder="{{'LIABILITIES.QUESTION5.LIABILITY_BALANCE2' | translate}}" [attAriaLabel]="'LIABILITIES.QUESTION5.LIABILITY_BALANCE2'|translate" attrId="{{'liabilityBalance'+index}}" [hasCurrencyMask]="true" [animatedLabel]="false" [hasTitle]="true"></app-animated-input>
					<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="liability.get('liabilityBalance').hasError('required') && displayErrors">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
					
			</div>
			

			<div class="form-group col-12 col-lg-3 input-wrapper mt-3" >

				<app-animated-input formControlName="liabilityMonthlyRefund" [type]="'text'" [attrId]="'liabilityBalance'+index" placeholder="{{'LIABILITIES.QUESTION5.MONTHLY_REFUND'|translate}}" [attAriaLabel]="'LIABILITIES.QUESTION5.MONTHLY_REFUND'|translate" attrId="{{'liabilityBalance'+index}}" [hasCurrencyMask]="true" [animatedLabel]="false" [hasTitle]="true"></app-animated-input>
				<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="liability.get('liabilityMonthlyRefund').hasError('required') && displayErrors">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
				</div>
			
			<div class="form-group col-12 col-lg-3 mt-3 input-wrapper" >
				<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-3">{{"LIABILITIES.QUESTION5.LIABILITIES_END_DATE"|translate}}</label>

				<div class="btn-group-toggle margin-top-3" data-toggle="buttons">
					<label class="app-label button-secondary-disabled" [ngClass]="{'selected':liability.get('liabilityEndDate').value==='1'}" style="width: auto;" tabindex="0">
						{{"LIABILITIES.QUESTION5.RADIO_MORE_18"|translate}}
						<input class="radio" type="radio" formControlName="liabilityEndDate" [value]="'1'" click2change tabindex="-1">
					</label>
					<label class="app-label button-secondary-disabled" [ngClass]="{'selected':liability.get('liabilityEndDate').value==='0'}" style="width: auto;" tabindex="0">
						{{"LIABILITIES.QUESTION5.RADIO_LESS_18"|translate}}
						<input class="radio" type="radio" formControlName="liabilityEndDate" [value]="'0'" click2change tabindex="-1">
					</label>
				</div> 

				<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="liability.get('liabilityEndDate').hasError('required') && displayErrors">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
			</div>

	</div>
</div>




// WEBPACK FOOTER //
// ./src/app/add-liability/add-liability.component.html